import React, { FC, useEffect } from 'react';
import styles from './CreateGameProviderForm.module.scss';
import { Checkbox, Input } from 'esa-ui-library';
import { Form } from '../../../components';
import { useStore } from '../../../../common';
import { validateForm } from '../GameProviders.helper';

interface CreateGameProviderFormProps {
	isEdit: boolean;
	onValidityChange?: (isValid: boolean) => void;
}

const CreateGameProviderForm: FC<CreateGameProviderFormProps> = ({ onValidityChange }): JSX.Element => {
	const [state, dispatch] = useStore();
	// const { token } = useContext(AuthContext);
	const { gameProviderForm, formErrors, success } = state;
	const [form, setForm] = React.useState(gameProviderForm);

	React.useEffect(() => {
		setForm(gameProviderForm);
	}, [gameProviderForm]);

	const onChange = (field: string, val: string) => {
		setForm((prev: any) => ({ ...prev, [field]: val }));
		dispatch('FORM', { field, value: val });
	};

	// const onSelect = (field: string, val: PropertyType[]) => {
	// 	dispatch('FORM', { field, value: val });
	// };

	const onSwitch = (field: string, val: boolean) => {
		setForm((prev: any) => ({ ...prev, [field]: val }));
		dispatch('FORM', { field, value: val });
	};

	useEffect(() => {
		const errors = validateForm(gameProviderForm);
		onValidityChange?.(!errors);
	}, [gameProviderForm]);

	// useEffect(() => {
	// 	if (isEdit && selectedGameProvider) {
	// 		dispatch('GAME_PROVIDER_INIT', { token, id: selectedGameProvider.id });
	// 	}
	// }, [isEdit, selectedGameProvider]);

	return (
		<section>
			<Form success={success}>
				<div className={styles.CreateGameProviderForm}>
					<Input
						className={styles.Input}
						type='text'
						label='Game Provider Name'
						value={form.game_provider_name}
						placeholder='Enter provider name'
						dataId='game-provider-name-field'
						required
						onChange={(val) => onChange('game_provider_name', val)}
						error={!!formErrors?.game_provider_name}
						errorMessage={formErrors?.game_provider_name}
					/>
					<Input
						className={styles.Input}
						type='number'
						label='Game Provider Id'
						value={form.game_provider_id}
						placeholder='Enter provider id'
						dataId='game-provider-id-field'
						required
						onChange={(val) => onChange('game_provider_id', val)}
						error={!!formErrors?.game_provider_id}
						errorMessage={formErrors?.game_provider_id}
					/>
					<Input
						className={styles.Input}
						type='text'
						label='Provider Url Live Desktop'
						value={form.provider_url_live_desktop}
						placeholder='Enter provider url live desktop'
						dataId='game-provider-url-live-desktop'
						required
						onChange={(val) => onChange('provider_url_live_desktop', val)}
						error={!!formErrors?.provider_url_live_desktop}
						errorMessage={formErrors?.provider_url_live_desktop}
					/>
					<Input
						className={styles.Input}
						type='text'
						label='Provider Url Test Desktop'
						value={form.provider_url_test_desktop}
						placeholder='Enter provider url test desktop'
						dataId='game-provider-url-test-desktop'
						required
						onChange={(val) => onChange('provider_url_test_desktop', val)}
						error={!!formErrors?.provider_url_test_desktop}
						errorMessage={formErrors?.provider_url_test_desktop}
					/>
					<Input
						className={styles.Input}
						type='text'
						label='Provider Url Live Mobile'
						value={form.provider_url_live_mobile}
						placeholder='Enter provider url live mobile'
						dataId='game-provider-url-live-mobile'
						required
						onChange={(val) => onChange('provider_url_live_mobile', val)}
						error={!!formErrors?.provider_url_live_mobile}
						errorMessage={formErrors?.provider_url_live_mobile}
					/>
					<Input
						className={styles.Input}
						type='text'
						label='Provider Url Test Mobile'
						value={form.provider_url_test_mobile}
						placeholder='Enter provider url test mobile'
						dataId='game-provider-url-test-mobile'
						required
						onChange={(val) => onChange('provider_url_test_mobile', val)}
						error={!!formErrors?.provider_url_test_mobile}
						errorMessage={formErrors?.provider_url_test_mobile}
					/>
					<Input
						className={styles.Input}
						type='text'
						label='History Url Live'
						value={form.history_url_live}
						placeholder='Enter history url live'
						dataId='history-url-live'
						required
						onChange={(val) => onChange('history_url_live', val)}
						error={!!formErrors?.history_url_live}
						errorMessage={formErrors?.history_url_live}
					/>
					<Input
						className={styles.Input}
						type='text'
						label='History Url Test'
						value={form.history_url_test}
						placeholder='Enter history url test'
						dataId='history-url-test'
						required
						onChange={(val) => onChange('history_url_test', val)}
						error={!!formErrors?.history_url_test}
						errorMessage={formErrors?.history_url_test}
					/>
					<Checkbox checked={form.active} onChange={(val) => onSwitch('active', val)} label='Active' />
				</div>
			</Form>
		</section>
	);
};

export { CreateGameProviderForm };
